export default __webpack_public_path__ + "static/social-index-05f5a9224351a198064b8d57b222b1a4.png";